<template>
    <div class="login-dialog-overlay" v-if="visible" @click.self="handleClose">
        <div class="login-dialog">
            <!-- 关闭按钮 -->
            <div class="close-btn" @click="handleClose">
                <i class="ri-close-circle-line"></i>
            </div>

            <!-- 左侧图片区 -->
            <div class="dialog-left">
                <img src="@/assets/images/1539836-1512487458.png" alt="登录背景" class="left-bg" />
                <div class="left-content">
                    <span class="left-title">欢迎来到点云研智网</span>
                    <span class="left-desc">全栈3D数字资产与定制服务平台</span>
                </div>
            </div>

            <!-- 右侧登录区 -->
            <div class="dialog-right">
                <!-- 登录方式选项卡 -->
                <div class="login-tabs" ref="loginTabs">
                    <div class="tab-item" ref="tabItems" v-for="(item, index) in tabList" :key="index"
                        :class="{ active: activeTab === index }" @click="activeTab = index">
                        {{ item.label }}
                    </div>
                    <div class="tab-line" :style="tabLineStyle"></div>
                </div>

                <!-- 登录内容区 -->
                <div class="login-content">
                    <!-- 微信二维码登录 -->
                    <div class="login-form" v-show="activeTab === 0">
                        <!-- 步骤提示 -->
                        <div class="steps">
                            <div class="step-item" data-index="1">
                                <span class="step-text">打开微信扫码</span>
                            </div>
                            <div class="step-divider"></div>
                            <div class="step-item" data-index="2">
                                <span class="step-text">关注微信公众号</span>
                            </div>
                            <div class="step-divider"></div>
                            <div class="step-item" data-index="3">
                                <span class="step-text">登录注册成功</span>
                            </div>
                        </div>
                        <!-- 二维码 -->
                        <div class="qrcode-wrapper">
                            <!-- <div id="wx_login_dialog_container" class="qrcode-image-container"></div> -->
                            <div class="qrcode-image-container" v-loading="!wxQrcodeUrl">
                                <img v-if="wxQrcodeUrl" :src="wxQrcodeUrl" alt="微信扫码登录"
                                    style="width: 100%; height: 100%; border-radius: 8px;">
                            </div>
                        </div>
                        <!-- 协议 -->
                        <div class="agreement">
                            <span>登录即代表您已同意</span>
                            <a href="/site/help-service?rand=128" target="_blank" rel="noopener">《点云研智网服务协议》</a>
                            <span>和</span>
                            <a href="/site/help-service?rand=216" target="_blank" rel="noopener">《点云研智网隐私政策》</a>
                        </div>
                    </div>

                    <!-- 验证码登录 -->
                    <div class="login-form form-sms" v-show="activeTab === 1">
                        <!-- 手机号输入 -->
                        <div class="input-group phone-group">
                            <div class="phone-prefix">
                                <span class="country-code">+86</span>
                                <i class="ri-arrow-down-s-fill"></i>
                            </div>
                            <input type="text" v-model="codeForm.phone" placeholder="请输入手机号" class="input-field">
                        </div>
                        <!-- 验证码输入 -->
                        <div class="input-group code-group">
                            <input type="text" v-model="codeForm.code" placeholder="请输入短信验证码" class="input-field">
                            <button class="code-btn" :disabled="!isPhoneValid || countdown > 0 || sendingCode"
                                @click="sendCode">
                                <template v-if="sendingCode">获取中...</template>
                                <template v-else-if="countdown > 0">{{ countdown }}s</template>
                                <template v-else>获取短信验证码</template>
                            </button>
                        </div>
                        <!-- 登录按钮 -->
                        <button class="login-btn" :disabled="!canCodeLogin || codeLoginLoading"
                            @click="handleCodeLogin">
                            <i v-if="codeLoginLoading" class="el-icon-loading"></i>
                            {{ codeLoginLoading ? '登录中...' : '注册/登录' }}
                        </button>
                        <!-- 协议勾选 -->
                        <div class="checkbox-group">
                            <label class="checkbox-label" @click="codeForm.agree = !codeForm.agree">
                                <div class="custom-checkbox" :class="{ checked: codeForm.agree }">
                                    <i class="ri-check-line"></i>
                                </div>
                                <span class="checkbox-text">我已阅读并同意<a href="/site/help-service?rand=128" target="_blank"
                                        rel="noopener">《点云研智网服务协议》</a>和<a href="/site/help-service?rand=216"
                                        target="_blank" rel="noopener">《点云研智网隐私政策》</a></span>
                            </label>
                            <span class="tip-text">未注册过的手机号，我们将自动帮你注册账号</span>
                        </div>
                    </div>

                    <!-- 密码登录 -->
                    <div class="login-form form-password" v-show="activeTab === 2">
                        <!-- 用户名输入 -->
                        <div class="input-group">
                            <input type="text" v-model="passwordForm.username" placeholder="请输入用户名/邮箱/手机号"
                                class="input-field" autocomplete="off" readonly @click="enableInput($event)" @focus="enableInput($event)">
                        </div>
                        <!-- 密码输入 -->
                        <div class="input-group password-group">
                            <input :type="showPassword ? 'text' : 'password'" v-model="passwordForm.password"
                                placeholder="请输入密码" class="input-field" @keyup.enter="handlePasswordLogin"
                                autocomplete="off" readonly @click="enableInput($event)" @focus="enableInput($event)">
                            <i class="password-eye" :class="showPassword ? 'ri-eye-line' : 'ri-eye-off-line'"
                                @click="showPassword = !showPassword"></i>
                        </div>
                        <!-- 底部链接 -->
                        <div class="bottom-links">
                            <span class="link-text">立即注册</span>
                            <span class="link-text">忘记密码</span>
                        </div>
                        <!-- 登录按钮 -->
                        <button class="login-btn" :disabled="!canPasswordLogin || passwordLoginLoading"
                            @click="handlePasswordLogin">
                            <i v-if="passwordLoginLoading" class="el-icon-loading"></i>
                            {{ passwordLoginLoading ? '登录中...' : '登录' }}
                        </button>
                        <!-- 协议勾选 -->
                        <div class="checkbox-group">
                            <label class="checkbox-label" @click="passwordForm.agree = !passwordForm.agree">
                                <div class="custom-checkbox" :class="{ checked: passwordForm.agree }">
                                    <i class="ri-check-line"></i>
                                </div>
                                <span class="checkbox-text">我已阅读并同意<a href="/site/help-service?rand=128" target="_blank"
                                        rel="noopener">《点云研智网服务协议》</a>和<a href="/site/help-service?rand=216"
                                        target="_blank" rel="noopener">《点云研智网隐私政策》</a></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { sendSms, smsLogin, passwordLogin, getWechatCode, checkWechatStatus } from '@/api/auth'
import { setToken, getToken } from '@/utils/auth'

export default {
    name: 'LoginDialog',
    data() {
        return {
            visible: false,
            activeTab: 0,
            tabList: [
                { value: 0, label: '微信一键登录' },
                { value: 1, label: '验证码登录' },
                { value: 2, label: '密码登录' }
            ],
            countdown: 0,
            timer: null,
            sendingCode: false,
            codeLoginLoading: false,
            passwordLoginLoading: false,
            codeForm: {
                phone: '',
                code: '',
                agree: false
            },
            passwordForm: {
                username: '',
                password: '',
                agree: false
            },
            tabLineWidth: 0,
            tabLineLeft: 0,
            resolvePromise: null,
            rejectPromise: null,
            showPassword: false,
            wxQrcodeUrl: '',
            sessionId: '',
            wxCheckTimer: null
        }
    },
    computed: {
        tabLineStyle() {
            return {
                width: `${this.tabLineWidth}px`,
                transform: `translateX(${this.tabLineLeft}px)`
            }
        },
        isPhoneValid() {
            const phoneReg = /^1[3-9]\d{9}$/
            return phoneReg.test(this.codeForm.phone)
        },
        canCodeLogin() {
            return this.isPhoneValid && this.codeForm.code.length >= 4
        },
        canPasswordLogin() {
            return this.passwordForm.username.trim() !== '' && this.passwordForm.password.trim() !== ''
        }
    },
    watch: {
        activeTab(val) {
            this.$nextTick(() => {
                this.updateTabLine()
                if (val === 0) {
                    this.getWxQrcode()
                } else {
                    if (this.wxCheckTimer) clearInterval(this.wxCheckTimer)
                }
            })
        },
        visible(val) {
            if (val) {
                this.$nextTick(() => {
                    this.updateTabLine()
                    if (this.activeTab === 0) {
                        this.getWxQrcode()
                    }
                })
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = ''
            }
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
        if (this.wxCheckTimer) {
            clearInterval(this.wxCheckTimer)
        }
        document.body.style.overflow = ''
    },
    methods: {
        show() {
            this.visible = true
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
                this.rejectPromise = reject
            })
        },
        hide() {
            this.visible = false
            this.resetForm()
        },
        handleClose() {
            this.hide()
            if (this.resolvePromise) {
                this.resolvePromise(false)
                this.resolvePromise = null
                this.rejectPromise = null
            }
        },
        resetForm() {
            this.codeForm = { phone: '', code: '', agree: false }
            this.passwordForm = { username: '', password: '', agree: false }
            this.countdown = 0
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
            if (this.wxCheckTimer) {
                clearInterval(this.wxCheckTimer)
                this.wxCheckTimer = null
            }
            this.wxQrcodeUrl = ''
            this.sessionId = ''
        },
        async getWxQrcode() {
            try {
                this.wxQrcodeUrl = ''
                if (this.wxCheckTimer) clearInterval(this.wxCheckTimer)

                const res = await getWechatCode()
                if (res.code === 200) {
                    this.wxQrcodeUrl = res.data.qrUrl
                    this.sessionId = res.data.sessionId
                    this.startCheckWxStatus()
                }
            } catch (error) {
                console.error('获取二维码失败', error)
            }
        },
        startCheckWxStatus() {
            if (this.wxCheckTimer) clearInterval(this.wxCheckTimer)
            this.wxCheckTimer = setInterval(async () => {
                try {
                    if (!this.visible || !this.sessionId) return

                    const res = await checkWechatStatus(this.sessionId)
                    if (res.code !== 200 || !res.data) return

                    const status = res.data.status
                    if (status === 'LOGGED_IN') {
                        clearInterval(this.wxCheckTimer)
                        this.wxCheckTimer = null
                        const token = res.data.user && res.data.user.token
                        if (token) {
                            this.$message.success('登录成功')
                            setToken(token)
                            // 非阻塞获取用户信息，即使失败也不影响登录流程
                            this.$store.dispatch('user/getUserInfo').catch(() => {
                                console.log('获取用户信息失败，但不影响登录流程')
                            })
                            this.hide()
                            if (this.resolvePromise) {
                                this.resolvePromise(true)
                            }
                        } else {
                            this.$message.error('登录失败，未获取到用户信息')
                        }
                        return
                    }

                    if (status === 'EXPIRED') {
                        clearInterval(this.wxCheckTimer)
                        this.wxCheckTimer = null
                        this.$message.warning('二维码已过期，正在刷新')
                        this.getWxQrcode()
                        return
                    }

                    if (status === 'ERROR') {
                        clearInterval(this.wxCheckTimer)
                        this.wxCheckTimer = null
                        this.$message.error('登录处理异常，请重试')
                        return
                    }
                } catch (error) {
                    // ignore
                }
            }, 2000)
        },
        updateTabLine() {
            if (this.$refs.tabItems && this.$refs.tabItems.length > 0) {
                const activeTabElement = this.$refs.tabItems[this.activeTab]
                if (activeTabElement) {
                    this.tabLineWidth = activeTabElement.offsetWidth
                    this.tabLineLeft = activeTabElement.offsetLeft
                }
            }
        },
        async sendCode() {
            if (!this.isPhoneValid) {
                this.$message.warning('请输入正确的手机号')
                return
            }
            this.sendingCode = true
            try {
                const res = await sendSms(this.codeForm.phone)
                if (res.code === 200) {
                    this.$message.success(res.msg || '验证码已发送')
                    this.countdown = 60
                    this.timer = setInterval(() => {
                        this.countdown--
                        if (this.countdown <= 0) {
                            clearInterval(this.timer)
                            this.timer = null
                        }
                    }, 1000)
                } else {
                    this.$message.error(res.msg || '发送验证码失败')
                }
            } catch (error) {
                this.$message.error(error.message || '发送验证码失败')
            } finally {
                this.sendingCode = false
            }
        },
        async handleCodeLogin() {
            if (!this.canCodeLogin) {
                this.$message.warning('请输入正确的手机号和验证码')
                return
            }
            if (!this.codeForm.agree) {
                this.$message.warning('请先同意用户协议和隐私政策')
                return
            }
            this.codeLoginLoading = true
            try {
                const res = await smsLogin({
                    phone: this.codeForm.phone,
                    code: this.codeForm.code
                })
                if (res.code === 200 && res.data) {
                        this.$message.success(res.msg || '登录成功')
                        console.log('Login response:', res)
                        console.log('Token from server:', res.data.token)
                        setToken(res.data.token)
                        console.log('Token in localStorage:', localStorage.getItem('token'))
                        // 非阻塞获取用户信息，即使失败也不影响登录流程
                        setTimeout(() => {
                            console.log('Before getUserInfo - token:', getToken())
                            this.$store.dispatch('user/getUserInfo').catch((error) => {
                                console.log('获取用户信息失败，但不影响登录流程:', error)
                            })
                        }, 100)
                        this.hide()
                        if (this.resolvePromise) {
                            this.resolvePromise(true)
                        }
                    } else {
                    this.$message.error(res.msg || '登录失败')
                }
            } catch (error) {
                this.$message.error(error.message || '登录失败')
            } finally {
                this.codeLoginLoading = false
            }
        },
        async handlePasswordLogin() {
            if (!this.canPasswordLogin) {
                this.$message.warning('请输入用户名和密码')
                return
            }
            if (!this.passwordForm.agree) {
                this.$message.warning('请先同意用户协议和隐私政策')
                return
            }
            this.passwordLoginLoading = true
            try {
                const res = await passwordLogin({
                    phone: this.passwordForm.username,
                    password: this.passwordForm.password
                })
                if (res.code === 200 && res.data) {
                        this.$message.success(res.msg || '登录成功')
                        console.log('Login response:', res)
                        console.log('Token from server:', res.data.token)
                        setToken(res.data.token)
                        console.log('Token in localStorage:', localStorage.getItem('token'))
                        // 非阻塞获取用户信息，即使失败也不影响登录流程
                        setTimeout(() => {
                            console.log('Before getUserInfo - token:', getToken())
                            this.$store.dispatch('user/getUserInfo').catch((error) => {
                                console.log('获取用户信息失败，但不影响登录流程:', error)
                            })
                        }, 100)
                        this.hide()
                        if (this.resolvePromise) {
                            this.resolvePromise(true)
                        }
                    } else {
                    this.$message.error(res.msg || '登录失败')
                }
            } catch (error) {
                this.$message.error(error.message || '登录失败')
            } finally {
                this.passwordLoginLoading = false
            }
        },
        // 启用输入框，移除readonly属性
        enableInput(event) {
            event.target.readOnly = false
            event.target.focus()
        }
    }
}
</script>

<style lang="scss" scoped>
.login-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.login-dialog {
    position: relative;
    display: flex;
    width: 800px;
    height: 520px;
    background: #1e2126;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);

    .close-btn {
        position: absolute;
        top: -40px;
        right: -40px;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;

        i {
            font-size: 36px;
            color: rgba(255, 255, 255, 0.5);
            transition: all 0.3s;
        }

        &:hover i {
            color: #fff;
            transform: rotate(180deg);
        }
    }
}

.dialog-left {
    position: relative;
    width: 320px;
    height: 100%;
    background: #2a2a2a;
    overflow: hidden;

    .left-bg {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .left-content {
        position: absolute;
        top: 80px;
        left: 30px;
        display: flex;
        flex-direction: column;

        .left-title {
            font-size: 24px;
            font-weight: 600;
            color: #fff;
            margin-bottom: 12px;
        }

        .left-desc {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.7);
        }
    }
}

.dialog-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 500px;
    height: calc(100% - 68px);
    padding-top: 32px;
    padding-bottom: 36px;

    .login-tabs {
        width: calc(100% - 80px);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 40px;
        padding-left: 40px;
        border-bottom: 1px solid #434343;

        .tab-item {
            font-size: 20px;
            line-height: 28px;
            color: #999;
            cursor: pointer;
            transition: all 0.3s;
            padding-bottom: 20px;

            &.active,
            &:hover {
                color: #FFF;
                font-weight: 500;
            }
        }

        .tab-line {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 3px;
            background-color: #e74c3c;
            transition: all 0.3s;
        }
    }

    .login-content {
        flex: 1;
        padding-top: 36px;

        .login-form {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 40px;

            .steps {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 20px;

                .step-item {
                    display: flex;
                    align-items: center;
                    color: #c0c0c0;
                    font-size: 12px;

                    &::before {
                        content: attr(data-index);
                        width: 18px;
                        height: 18px;
                        margin-right: 4px;
                        background-color: #409EFF;
                        border-radius: 50px;
                        font-size: 12px;
                        line-height: 18px;
                        text-align: center;
                        color: #fff;
                    }
                }

                .step-divider {
                    width: 12px;
                    height: 1px;
                    margin: 0 6px;
                    background: #565656;
                }
            }

            .qrcode-wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 200px;
                margin-bottom: 16px;

                .qrcode-image-container {
                    width: 180px;
                    height: 180px;
                    display: flex;
                    justify-content: center;

                    ::v-deep iframe {
                        margin: 0 auto;
                    }
                }
            }

            .agreement {
                text-align: center;
                font-size: 12px;
                color: #707070;

                a {
                    color: #999;
                    text-decoration: none;

                    &:hover {
                        color: #8ba7de;
                    }
                }
            }

            // 验证码登录和密码登录表单样式
            &.form-sms,
            &.form-password {
                .input-group {
                    width: 100%;
                    position: relative;
                    margin-bottom: 20px;

                    .input-field {
                        width: 100%;
                        height: 56px;
                        padding: 0 24px;
                        background: #33373f;
                        border-radius: 8px;
                        box-sizing: border-box;
                        outline: none;
                        border: none;
                        color: #fff;
                        font-size: 16px;

                        &::placeholder {
                            color: #777;
                        }
                    }

                    .phone-prefix {
                        position: absolute;
                        left: 24px;
                        top: 50%;
                        transform: translateY(-50%);
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        cursor: pointer;

                        .country-code {
                            color: #fff;
                            font-size: 18px;
                            font-weight: 500;
                        }

                        i {
                            color: #999;
                            font-size: 20px;
                        }
                    }

                    &.phone-group .input-field {
                        padding-left: 110px;
                    }

                    &.code-group {
                        .code-btn {
                            position: absolute;
                            right: 24px;
                            top: 50%;
                            transform: translateY(-50%);
                            background: transparent;
                            border: none;
                            color: #888;
                            font-size: 16px;
                            cursor: pointer;

                            &:not(:disabled):hover {
                                color: #aaa;
                            }

                            &:disabled {
                                color: #666;
                                cursor: not-allowed;
                            }
                        }
                    }

                    &.password-group {
                        .password-eye {
                            position: absolute;
                            right: 24px;
                            top: 50%;
                            transform: translateY(-50%);
                            color: #666;
                            font-size: 20px;
                            cursor: pointer;
                            transition: color 0.3s;

                            &:hover {
                                color: #999;
                            }
                        }
                    }
                }

                .login-btn {
                    width: 100%;
                    height: 56px;
                    background: #43609B;
                    border-radius: 8px;
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 20px;
                    border: none;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    transition: background 0.3s;

                    &:hover {
                        background: #3a5589;
                    }

                    &:disabled {
                        background: rgba(67, 96, 155, 0.6);
                        cursor: not-allowed;
                    }
                }

                .checkbox-group {
                    width: 100%;
                    margin-top: 16px;

                    .checkbox-label {
                        display: flex;
                        align-items: flex-start;
                        gap: 8px;
                        cursor: pointer;
                        user-select: none;

                        .custom-checkbox {
                            width: 14px;
                            height: 14px;
                            border: 1px solid rgba(255, 255, 255, 0.5);
                            border-radius: 2px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-shrink: 0;
                            margin-top: 2px;
                            transition: all 0.2s;

                            i {
                                font-size: 12px;
                                color: #409EFF;
                                opacity: 0;
                            }

                            &.checked {
                                background-color: #409EFF;
                                border-color: #409EFF;

                                i {
                                    opacity: 1;
                                    color: #fff;
                                }
                            }
                        }

                        .checkbox-text {
                            font-size: 12px;
                            color: rgba(255, 255, 255, 0.5);
                            line-height: 1.5;

                            a {
                                color: #8ba7de;
                                text-decoration: none;

                                &:hover {
                                    text-decoration: underline;
                                }
                            }
                        }
                    }

                    .tip-text {
                        display: block;
                        font-size: 12px;
                        color: #707070;
                        margin-top: 6px;
                        padding-left: 22px;
                    }
                }

                .bottom-links {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;

                    .link-text {
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.5);
                        cursor: pointer;
                        transition: color 0.3s;

                        &:hover {
                            color: rgba(255, 255, 255, 0.8);
                        }
                    }
                }
            }

            // 验证码登录特殊样式
            &.form-sms {
                .login-btn {
                    margin-top: 100px;
                }
            }

            // 密码登录特殊样式
            &.form-password {
                .login-btn {
                    margin-top: 0;
                }
            }
        }
    }
}
</style>
